/** Segment sizes shown in the sticky list footer (Option B). */
export const LIST_PAGE_SIZE_OPTIONS = Object.freeze([25, 50, 100]);
export const DEFAULT_LIST_PAGE_SIZE = 50;

const STORAGE_PREFIX = 'demandjet.listPageSize.';

export function normalizePageSize(value) {
  const n = Number(value);
  return LIST_PAGE_SIZE_OPTIONS.includes(n) ? n : DEFAULT_LIST_PAGE_SIZE;
}

export function loadListPageSize(storageKey, fallback = DEFAULT_LIST_PAGE_SIZE) {
  if (!storageKey) return normalizePageSize(fallback);
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${storageKey}`);
    if (raw == null) return normalizePageSize(fallback);
    return normalizePageSize(raw);
  } catch {
    return normalizePageSize(fallback);
  }
}

export function saveListPageSize(storageKey, pageSize) {
  const next = normalizePageSize(pageSize);
  if (!storageKey) return next;
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${storageKey}`, String(next));
  } catch {
    // Ignore quota / private-mode write failures.
  }
  return next;
}

export function listPageCount(total, pageSize) {
  const size = normalizePageSize(pageSize);
  const n = Math.max(0, Number(total) || 0);
  return n === 0 ? 1 : Math.ceil(n / size);
}

export function clampListPage(page, total, pageSize) {
  const count = listPageCount(total, pageSize);
  const p = Math.max(1, Number(page) || 1);
  return Math.min(p, count);
}

export function listPageRange(total, page, pageSize) {
  const size = normalizePageSize(pageSize);
  const n = Math.max(0, Number(total) || 0);
  if (n === 0) {
    return { start: 0, end: 0, page: 1, pageCount: 1 };
  }
  const safePage = clampListPage(page, n, size);
  const start = (safePage - 1) * size + 1;
  const end = Math.min(n, safePage * size);
  return {
    start,
    end,
    page: safePage,
    pageCount: listPageCount(n, size),
  };
}

export function sliceListPage(items = [], page, pageSize) {
  const size = normalizePageSize(pageSize);
  const total = items.length;
  const safePage = clampListPage(page, total, size);
  const startIndex = (safePage - 1) * size;
  return {
    pageItems: items.slice(startIndex, startIndex + size),
    ...listPageRange(total, safePage, size),
    total,
    pageSize: size,
  };
}
